import { WarbandPage } from '../types';

const validPages: WarbandPage[] = ['manage', 'pregame', 'play', 'postgame'];

export interface UrlState {
  warbandId: string | null;
  currentPage: WarbandPage;
  manageTabIndex: number;
  playTabIndex: number;
}

const sanitizeTabIndex = (value: string | null, max: number): number => {
  if (value === null) {
    return 0;
  }

  const parsed = Number.parseInt(value, 10);

  if (Number.isNaN(parsed) || parsed < 0) {
    return 0;
  }

  if (parsed > max) {
    return max;
  }

  return parsed;
};

const sanitizePage = (value: string | null): WarbandPage => {
  if (value && validPages.includes(value as WarbandPage)) {
    return value as WarbandPage;
  }

  return 'manage';
};

export const parseUrlState = (): UrlState => {
  const params = new URLSearchParams(window.location.search);

  return {
    warbandId: params.get('w'),
    currentPage: sanitizePage(params.get('p')),
    // Manage pages have 5 tabs, play pages 3.
    manageTabIndex: sanitizeTabIndex(params.get('tm'), 4),
    playTabIndex: sanitizeTabIndex(params.get('tp'), 2),
  };
};

export const writeUrlState = (state: UrlState): void => {
  const url = new URL(window.location.href);

  if (!state.warbandId) {
    url.searchParams.delete('w');
    url.searchParams.delete('p');
    url.searchParams.delete('tm');
    url.searchParams.delete('tp');
  } else {
    url.searchParams.set('w', state.warbandId);
    url.searchParams.set('p', state.currentPage);
    url.searchParams.set('tm', String(state.manageTabIndex));
    url.searchParams.set('tp', String(state.playTabIndex));
  }

  const search = url.searchParams.toString();
  const nextUrl = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (nextUrl !== currentUrl) {
    window.history.replaceState({}, '', nextUrl);
  }
};
